export type HumanFilterOperation = "=" | ">" | "<" | ">=" | "<=" |
	"!like" | "like" | "!=" | "^" | "!^" | "$" | "!$" |
	"in" | "between" | "in" | "not in" | "is null" | "is not null" | "is date";

export class HumanFilter {

	public static getTranslationOperator(operator: string): string {
		let operators = [
			{val: "=", text: "eq"}, {val: "!=", text: "neq"},
			{val: "<", text: "lt"}, {val: ">", text: "gt"},
			{val: ">=", text: "gte"}, {val: "<=", text: "lte"},
			{val: "between", text: "between"},
			{val: "like", text: "like"}, {val: "not like", text: "not_like"},
			{val: "^", text: "sw"}, {val: "!^", text: "nsw"},
			{val: "$", text: "ew"}, {val: "!$", text: "new"},
			{val: "is null", text: "is null"}, {val: "is not null", text: "is_not_null"},
			{val: "in", text: "in"}, {val: "not in", text: "not_in"},
			{val: "is date", text: "is"},
		];
		let res = operators.find((o) => o.val == operator);
		if (!res) {
			throw Error("Invalid operator: " + operator);
		}
		return res.text;
	}

	public static getQuickFilters(fields: string[], value: string): HumanFilter[] {

		let operator = "^" as HumanFilterOperation;
		if (value.startsWith("*")) {
			operator = "$";
			value = value.substr(1);
			if (value.endsWith("*")) {
				operator = "like";
				value = value.substring(0, value.length - 1);
			}
		} else if (value.endsWith("*")) {
			value = value.substring(0, value.length - 1);
		}

		return fields.map((field, i) => new HumanFilter({
			Field: field,
			Operator: operator as HumanFilterOperation,
			Values: [value],
			IsOr: i != 0,
		}));
	}

	public Field: string = "";
	public Operator: HumanFilterOperation = "=";
	public Values: string[] = [];
	public IsOr: boolean = false;

	constructor(data?: { Field: string, Operator: HumanFilterOperation, Values: string[], IsOr?: boolean }) {
		if (!data) {
			return;
		}
		this.Field = data.Field;
		this.Operator = data.Operator;
		this.Values = data.Values;
		this.IsOr = data.IsOr || false;
	}

	public getText(): string {
		if (this.Operator == "between") {
			return this.Field + " BETWEEN " + this.Values[0] + " AND " + this.Values[1];
		}
		let values = this.Values.length;
		if (values == 0) {
			return this.Field + " " + this.Operator;
		}
		if (values > 1) {
			return this.Field + " " + this.Operator + " (" + this.Values.join(", ") + ")";
		}
		return this.Field + " " + this.Operator + " " + this.Values[0];
	}

	public getValueAmount(): number {
		if (this.Operator == "between") {
			return 2;
		}
		if (this.Operator == "in" || this.Operator == "not in") {
			return -1;
		}
		if (this.Operator == "is null" || this.Operator == "is not null") {
			return 0;
		}
		return 1;
	}

}
